export const PhoneFrame = ({ children, testId = "phone-frame", className = "" }) => (
  <div
    data-testid={testId}
    className={`relative mx-auto w-[280px] sm:w-[300px] rounded-[2.6rem] border border-slate-200 bg-slate-900 p-[10px] shadow-[0_24px_60px_-24px_rgba(15,23,42,0.35)] ${className}`}
  >
    <div className="absolute left-1/2 top-[18px] z-20 h-[22px] w-[96px] -translate-x-1/2 rounded-full bg-slate-900" />
    <div className="relative h-[560px] overflow-hidden rounded-[2rem] bg-white">
      {children}
    </div>
  </div>
);
